var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'font-awesome')?_c('i',{staticClass:"fa",class:("fa-" + _vm.name),attrs:{"aria-hidden":"true"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }